<template>
  <div class="basic_wrap user-page records-page">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('moneybag.rechargeRecord') }}
      </div>
    </div>
    <div class="user_yw">
      <div>
        <p>{{ $t('moneybag.accountBalance') }}</p>
        <p>{{ $formatPen(funds) }}</p>
      </div>
      <div>
        <p>{{ $t('user.availableBalance') }}</p>
        <p>{{ $formatPen(mymoney) }}</p>
      </div>
    </div>
    <!-- <div class="user_zrzc">
            <span @click="$router.push('/invest')">{{$t('moneybag.recharge')}}</span>
            <span @click="$router.push('/cash')">{{$t('moneybag.withdraw')}}</span>
        </div> -->
    <div class="detail_box">
      <van-empty
        v-if="listShow"
        :description="$t('item.noData')"
      />
      <div
        v-for="item in data"
        :key="item.id"
        class="item"
      >
        <div class="de_wrap">
          <p class="tit">
            {{ $t('invest_qrcode.recharge') }}
            (<template v-if="item.status =='0'||item.status =='3'">
              {{ $t('invest_qrcode.submittedSuccessfully') }}
            </template>
            <template v-if="item.status =='1'">
              {{ $t('invest.success') }}
            </template>
            <template v-if="item.status =='2'">
              {{ $t('invest.failed') }}
            </template>)
          </p>
          <template v-if="item.memo!=null">
            <p class="time">
              {{ $t('cash.remark') }}:{{ item.memo }}
            </p>
          </template>
          <p class="time">
            {{ item.orderid }}
          </p>
          <p class="time">
            {{ item.time }}
          </p>
        </div>
        <div
          class="price"
          :class="item.status =='1'?'add':item.status =='2'?'del':''"
          v-html="$formatPen(item.money)"
        />
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem);

    export default {
        name: "RechargeRecord",
        data() {
            return {
				lang:this.$i18n.locale||"zh_cn",
                data: [],
                list: {},
                account: 0,
                option: [],
                listShow:false,
                funds: 0,
                mymoney: 0,
                userName:''
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            Fetch('/user/funds',{
                reason_id: 1
            }).then(r => {
                this.option.push({
                    text: this.$t('moneybag.types'),
                    value: 0
                })
                
                this.mymoney = r.data.mymoney;
                this.funds = r.data.money;
                this.userName = r.data.username;
            });
            Fetch('/user/recharge_search').then(r=>{
                this.showError(r.data.length);
                this.data = r.data;
            })
        },
        methods: {
            chooseType(val) {
                if(val == 0){
                    Fetch('/user/funds').then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }else{
                    Fetch('/user/funds',{
                        reason_id: val
                    }).then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }
            },
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
    .records-page {
        min-height: 100vh;
        box-sizing: border-box;
        padding-bottom: calc(var(--app-bottom-menu-height) + 24px + env(safe-area-inset-bottom, 0px));
        background: #f5f5f5;
        color: #333;
    }
    .red_top_bg {
        height: 50px;
        background: #fff;
        position: relative;
        border-bottom: 1px solid #eceff2;
        color: #101827;
    }
	.back_left { filter: brightness(0); opacity: 1; }
	.big_tit { top: 13px; font-size: 16px; font-weight: 500; color: #333; }
	.user_yw{
        display: flex;
		text-align: center;
		width: auto;
		position: relative;
		top: auto;
		background: #FFFFFF;
		left: auto;
		margin: 16px 16px 0;
		border-radius: 0;
		padding: 18px 0;
		box-shadow: none;
        div{
            width: 50%;
			& + div { border-left: 1px solid #edf0f2; }
        }
		p:nth-child(1){
			font-size: 12px;
			color: #758094;
			margin-bottom: 8px;
		}
		p:nth-child(2){
			font-size: 16px;
			font-weight: bold;
			color: #101827;
		}
	}
	.user_zrzc{
		text-align: center;
		width: auto;
		position: relative;
		top: auto;
		background: #FFFFFF;
		left: auto;
		margin: 0 16px;
		border-radius: 0;
		padding: 0 10px 14px;
		display: flex;
		justify-content: space-between;
		text-align: center;
		span{
			width: 40%;
			background: #ee4d2d;
			color: #FFFFFF;
			margin: 0 6px;
			padding: 10px;
			border-radius: 6px;
			font-size: 12px;
		}
	}

    .detail_box {
        width: auto;
		margin: 16px;
        overflow: hidden;
        background: #fff;
        border-radius: 0;
        padding: 0 12px;
		box-shadow: none;
		/deep/ .van-empty { padding: 44px 0; }
        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            padding: 16px 4px;
            border-bottom: 1px solid #edf0f2;
			&:last-child { border-bottom: 0; }

            .de_wrap {
                flex: 2;
				min-width: 0;

                .tit {
                    font-size: 13px;
                    color: #333;
                    line-height: 20px;
                    font-weight: bold;
                }

                .time {
                    font-size: 12px;
                    color: #888;
                    line-height: 17px;
                    margin-top: 6px;
					word-break: break-word;
                }
            }

            .price {
                flex: 1;
                font-size: 14px;
                line-height: 28px;
                font-weight: bold;
                text-align: right;
                color: #ccc;
                white-space: nowrap;
                &.add {
                    color: #ee4d2d;
                }
                &.del {
                    color: #3f9b62;
                }
            }
        }
    }
	.records-page { background: #f5f5f5; }
	.user_yw { margin: 10px 0 0; border-bottom: 1px solid #ededed; }
	.detail_box { margin: 10px 0 0; padding: 0 16px; border-radius: 0; }
	.detail_box .item { min-height: 70px; padding: 14px 0; }
	.detail_box .item .de_wrap .tit { font-weight: 500; }
</style>
